import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Orders.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/cartCheckout',
    name: 'cartCheckout',
    component: () => import('../views/Cart.vue'),
    meta: { requiresAuth : true }
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import('../views/Orders.vue'),
    meta: { requiresAuth : true , roles: ['admin', 'superadmin'] }
  },
  {
    path: '/returns',
    name: 'returns',
    component: () => import('../views/Returns.vue'),
    meta: { requiresAuth : true , roles: ['admin', 'superadmin'] }
  },
  {
    path: '/return/:id',
    name: 'return',
    component: () => import('../views/Return.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/reviews/:productId?',
    name: 'reviews',
    component: () => import('../views/AllReviews.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'productreviewer']  }
  },
  {
    path: '/popup-campaigns',
    name: 'popupcampaigns',
    component: () => import('../views/Marketing/PopUpCampaigns.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/popup-campaign/:id',
    name: 'popupcampaigns',
    component: () => import('../views/Marketing/PopUpCampaign.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/generate-invoices',
    name: 'generate-invoices',
    component: () => import('../views/GenerateInvoices.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/download-xml',
    name: 'download-xml',
    component: () => import('../components/Product/DownloadXML.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/grouped-orders',
    name: 'groupedorders',
    component: () => import('../views/GroupedOrders.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/simple-orders',
    name: 'simpleorders',
    component: () => import('../views/SimpleGroupedOrders.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/mixed-orders',
    name: 'mixedorders',
    component: () => import('../views/MixedGroupedOrders.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/shelves',
    name: 'shelves',
    component: () => import('../views/Shelves.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/boxes',
    name: 'boxes',
    component: () => import('../views/Boxes.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/searches',
    name: 'searches',
    component: () => import('../views/Searches.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/change-statuses-orders',
    name: 'changestatusesorders',
    component: () => import('../views/OrderChangeStatuses.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing-costs',
    name: 'marketingcosts',
    component: () => import('../views/MarketingCosts.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'reports']  }
  },
  {
    path: '/gradinite',
    name: 'gradinite',
    component: () => import('../views/Kindergartens.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/gradinite-opinii',
    name: 'gradinite-opinii',
    component: () => import('../views/KindergartensOpinions.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/new-products',
    name: 'new-products',
    component: () => import('../views/NewProducts.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/order/:id',
    name: 'order',
    component: () => import('../views/Order.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/order2/:id',
    name: 'order2',
    component: () => import('../views/Order2.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/order-crypt/:idCrypt',
    name: 'orderCrypt',
    component: () => import('../views/OrderCrypt.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/members',
    name: 'members',
    component: () => import('../views/Members.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  }, 
  {
    path: '/member/:id',
    name: 'member',
    component: () => import('../views/Member.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },  
  {
    path: '/new-member',
    name: 'newmember',
    component: () => import('../views/NewMember.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-attribute',
    name: 'newattribute',
    component: () => import('../views/NewAttribute.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/download-members',
    name: 'downloadmembers',
    component: () => import('../views/DownloadMembers.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/postal-awb',
    name: 'postalawb',
    component: () => import('../views/PostOfficeAWBs.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/cache-reports',
    name: 'cachereports',
    component: () => import('../views/CacheReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/stock-reports',
    name: 'stockreports',
    component: () => import('../views/StockReports.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/product/:productId',
    name: 'product',
    component: () => import('../views/Product.vue'),
    props: true,
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/products/:term?',
    name: 'products',
    component: () => import('../views/ProductList.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-product',
    name: 'newproduct',
    component: () => import('../views/NewProduct.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/import-products',
    name: 'importproducts',
    component: () => import('../views/ImportProducts.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/update-products',
    name: 'updateproducts',
    component: () => import('../views/UpdateProducts.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/import-products-pdfs',
    name: 'importproductspdfs',
    component: () => import('../views/ImportProductPdfs.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/import-list-prices-nexus',
    name: 'import-list-prices-nexus',
    component: () => import('../views/ImportListPricesNexus.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/generate-import-file',
    name: 'generateimportfile',
    component: () => import('../views/GenerateImportFile.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-category',
    name: 'newcategory',
    component: () => import('../views/NewCategory.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('../views/Categories.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/category/:id',
    name: 'category',
    component: () => import('../views/Category.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-category-library',
    name: 'newCategoryLibrary',
    component: () => import('../views/NewCategoryLibrary.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/categories-libraries',
    name: 'categoriesLibraries',
    component: () => import('../views/CategoriesLibraries.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/category-library/:id',
    name: 'categoryLibrary',
    component: () => import('../views/CategoryLibrary.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/link-categories-libraries',
    name: 'linkCategoriesLibraries',
    component: () => import('../views/LinkCategoriesLibraries.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/voucher/:id',
    name: 'voucher',
    component: () => import('../views/Voucher.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/vouchers',
    name: 'vouchers',
    component: () => import('../views/Vouchers.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-voucher',
    name: 'newvoucher',
    component: () => import('../views/NewVoucher.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/banners',
    name: 'banners',
    component: () => import('../views/Banners.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/banner/:id',
    name: 'banner',
    component: () => import('../views/Banner.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-banner',
    name: 'newbanner',
    component: () => import('../views/NewBanner.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/sliders',
    name: 'sliders',
    component: () => import('../views/Sliders.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/slider/:id',
    name: 'slider',
    component: () => import('../views/Slider.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-slider',
    name: 'newslider',
    component: () => import('../views/NewSlider.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-gift',
    name: 'newgift',
    component: () => import('../views/NewGift.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/gift/:id',
    name: 'gift',
    component: () => import('../views/Gift.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/gifts',
    name: 'gifts',
    component: () => import('../views/Gifts.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/email-bonus/:id',
    name: 'emailbonus',
    component: () => import('../views/EmailBonus.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/email-bonuses',
    name: 'emailbonuses',
    component: () => import('../views/EmailBonuses.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-email-bonus',
    name: 'newemailbonus',
    component: () => import('../views/NewEmailBonus.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-bonus',
    name: 'newbonus',
    component: () => import('../views/NewBonus.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/bonus/:id',
    name: 'bonus',
    component: () => import('../views/Bonus.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/daily-offer',
    name: 'dailyoffer',
    component: () => import('../views/DailyOffer.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/reports-salesbydate',
    name: 'reportssalesbydate',
    component: () => import('../views/Reports/ReportsSalesByDate.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'reports'] }
  },
  {
    path: '/graph-reports',
    name: 'graphreports',
    component: () => import('../views/Reports/GraphReports.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'reports']  }
  },
  {
    path: '/reports-salesbyproducts',
    name: 'reportssalesbyproducts',
    component: () => import('../views/Reports/ReportsSalesByProducts.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'reports']  }
  },
  {
    path: '/reports-salesbyproduct/:productId/:startDate/:endDate',
    name: 'reportssalesbyproduct',
    component: () => import('../views/Reports/ReportsSalesByProduct.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'reports']  }
  },
  {
    path: '/author-reports',
    name: 'authorreports',
    component: () => import('../views/Reports/AuthorReports.vue'),
    meta: { requiresAuth : true, roles: [ 'autorreports']  }
  },
  {
    path: '/google-reports',
    name: 'googlereports',
    component: () => import('../views/Reports/GoogleReports.vue'),
    meta: { requiresAuth : true, roles: ['googleads']  }
  },
  {
    path: '/google-connect',
    name: 'googleconnect',
    component: () => import('../views/Reports/GoogleConnect.vue'),
    meta: { requiresAuth : true, roles: ['googleads'] }
  },
  {
    path: '/management-exportorders',
    name: 'managementexportorders',
    component: () => import('../views/Management/ExportOrders.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/management-currentproductprices',
    name: 'managementcurrentproductprices',
    component: () => import('../views/Management/CurrentProductPrices.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/management-orderssingleproducts',
    name: 'managementorderssingleproducts',
    component: () => import('../views/Management/OrdersSingleProducts.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/management-orderspackages',
    name: 'managementorderspackages',
    component: () => import('../views/Management/OrdersPackages.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/latest-products',
    name: 'latestproducts',
    component: () => import('../views/LatestProducts.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/latest-product/:id',
    name: 'latestproduct',
    component: () => import('../views/LatestProduct.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/landings',
    name: 'landings',
    component: () => import('../views/Landings.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/landings-launches',
    name: 'landings-launches',
    component: () => import('../views/LandingsLaunches.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/landing/:landingId',
    name: 'landing',
    component: () => import('../views/Landing.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] },
    props: true
  },
  {
    path: '/bf-landing',
    name: 'bflanding',
    component: () => import('../views/BFLanding.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/launch/:id',
    name: 'launch',
    component: () => import('../views/BFLaunch.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/limited-offer/:id',
    name: 'limitedoffer',
    component: () => import('../views/BFLimitedOffer.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/campaigns',
    name: 'marketingcampaigns',
    component: () => import('../views/Marketing/Campaigns.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/gradual-campaign',
    name: 'marketinggradualcampaign',
    component: () => import('../views/Marketing/GradualCampaign.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/epic-offer-campaign',
    name: 'marketingepicoffercampaign',
    component: () => import('../views/Marketing/EpicOfferCampaign.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
    {
    path: '/marketing/wow-bestseller-campaign',
    name: 'marketingwowbestsellercampaign',
    component: () => import('../views/Marketing/WowBestsellerCampaign.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/fb-authors',
    name: 'fb-author',
    component: () => import('../views/Marketing/FBAuthors.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/fb-author/:id',
    name: 'fb-author-id',
    component: () => import('../views/Marketing/FBAuthor.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/fb-authors-campaigns/',
    name: 'fb-author-campaigns',
    component: () => import('../views/Marketing/FBAuthorsCampaigns.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/promotional-packages',
    name: 'promotional-packages',
    component: () => import('../views/Marketing/PromotionalPackages.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/promotional-packages/:id',
    name: 'edit-package',
    component: () => import('../views/Marketing/EditPackage.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/colaborari-permanente',
    name: 'colaborari-permanente',
    component: () => import('../views/Marketing/PermanentCollabs.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/colaborari-permanente',
    name: 'colaborari-permanente',
    component: () => import('../views/Marketing/PermanentCollabs.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/colaborator/:id',
    name: 'colaborator',
    component: () => import('../views/Marketing/Colaborator.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/notification-lists',
    name: 'marketingnotificationlists',
    component: () => import('../views/Marketing/Notifications.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/notification/:id',
    name: 'marketingnotification',
    component: () => import('../views/Marketing/Notification.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/cross-sale-campaigns',
    name: 'crosssalecampaigns',
    component: () => import('../views/Marketing/CrossSaleCampaigns.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/cross-sale-campaign/add',
    name: 'crosssalecampaignadd',
    component: () => import('../views/Marketing/CrossSaleCampaign.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/cross-sale-campaign/:id',
    name: 'crosssalecampaign',
    component: () => import('../views/Marketing/CrossSaleCampaign.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/marketing/qr-code',
    name: 'marketingqrcode',
    component: () => import('../views/Marketing/QrCodeGenerator.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/bf-footer-notification/:id',
    name: 'bffooternotification',
    component: () => import('../views/BFFooterNotification.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/users/:id',
    name: 'warehouse-user',
    component: () => import('../views/Warehouse/User.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/users',
    name: 'warehouse-users',
    component: () => import('../views/Warehouse/Users.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/reports',
    name: 'warehouse-reports',
    component: () => import('../views/Warehouse/Reports.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/bonus-report',
    name: 'warehouse-bonus-report',
    component: () => import('../views/Warehouse/BonusReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/add-user',
    name: 'warehouse-add-user',
    component: () => import('../views/Warehouse/AddUser.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/critical-stock',
    name: 'warehouse-critical-stock',
    component: () => import('../views/Warehouse/CriticalStock.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/reports/:id',
    name: 'warehouse-user-report',
    component: () => import('../views/Warehouse/UserReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/extra-activities',
    name: 'warehouse-extra-activities',
    component: () => import('../views/Warehouse/ExtraActivities.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/inventory',
    name: 'warehouse-inventory',
    component: () => import('../views/Warehouse/Inventory.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/pending-stock',
    name: 'warehouse-pending-stock',
    component: () => import('../views/Warehouse/PendingStock.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/warehouse/documente-nexus',
    name: 'warehouse-documente-nexus',
    component: () => import('../views/Warehouse/NexusDocuments.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/new-print',
    name: 'newprint',
    component: () => import('../views/PrintOrders/NewPrintOrder.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/print/:id',
    name: 'print',
    component: () => import('../views/PrintOrders/PrintOrder.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/prints',
    name: 'prints',
    component: () => import('../views/PrintOrders/PrintOrders.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/category-landings',
    name: 'categorylandings',
    component: () => import('../views/CategoryLandings/CategoryLandings.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/category-landing/:id',
    name: 'categorylanding',
    component: () => import('../views/CategoryLandings/CategoryLanding.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/category-landing-product/:id',
    name: 'categorylandingproduct',
    component: () => import('../views/CategoryLandings/CategoryLandingProduct.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/footer-links',
    name: 'footerlinks',
    component: () => import('../views/FooterLinks/FooterLinks.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/Settings.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/settings/search',
    name: 'searchsettings',
    component: () => import('../views/SearchSettings.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori',
    name: 'distributors',
    component: () => import('../views/Distributors/Summary.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/adauga-comanda/:clientId?',
    name: 'distributors/add-order',
    component: () => import('../views/Distributors/AddOrder.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/comenzi/:orderId',
    name: 'distributors/order',
    component: () => import('../views/Distributors/Order.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/retururi/',
    name: 'distributors/retururi',
    component: () => import('../views/Distributors/Returns.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/retururi/:id',
    name: 'distributors/retururi',
    component: () => import('../views/Distributors/ViewReturns.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/import-raport-vanzari',
    name: 'distributors/import-sales-report',
    component: () => import('../views/Distributors/ImportSalesReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/import-avize',
    name: 'distributors/import-notice',
    component: () => import('../views/Distributors/ImportNotice.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/export-produse',
    name: 'distributors/ProductsExport',
    component: () => import('../views/Distributors/ProductsExport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/clienti',
    name: 'distributors/clients',
    component: () => import('../views/Distributors/Clients.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/clienti/:clientId',
    name: 'distributors/client',
    component: () => import('../views/Distributors/Client.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/adauga-client',
    name: 'distributors/add-client',
    component: () => import('../views/Distributors/AddClient.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/documente',
    name: 'distributors/documents',
    component: () => import('../views/Distributors/Documents.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/comenzi',
    name: 'distributors/orders',
    component: () => import('../views/Distributors/Orders.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/comenzi2',
    name: 'distributors/orders2',
    component: () => import('../views/Distributors/Orders_old.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/clienti/:clientId/adauga-locatie',
    name: 'distributors/add-shipping-location',
    component: () => import('../views/Distributors/AddShippingLocation.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/editare-locatie/:shippingLocationId',
    name: 'distributors/edit-shipping-location',
    component: () => import('../views/Distributors/ShippingLocation.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/adauga-incasare',
    name: 'distributors/add-payment',
    component: () => import('../views/Distributors/AddPayment.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/incasari',
    name: 'distributors/payments',
    component: () => import('../views/Distributors/Payments.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/incasari/:id',
    name: 'distributors/payment',
    component: () => import('../views/Distributors/Payment.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {

    path: '/distribuitori/produse',
    name: 'distributors/products',
    component: () => import('../views/Distributors/ProductsInNotices.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/raport-sold',
    name: 'distributors/sold-report',
    component: () => import('../views/Distributors/SoldReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/fisa-client',
    name: 'distributors/fisa-client',
    component: () => import('../views/Distributors/FisaClient.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/raport-vanzari-distribuitori',
    name: 'distributors/sales-reports-distributors',
    component: () => import('../views/Distributors/SalesReportDistributors.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/raport-stocuri',
    name: 'distributors/stock-reports',
    component: () => import('../views/Distributors/StockReports.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/raport-vanzari-dupa-coduri-de-bare',
    name: 'distributors/raport-vanzari-dupa-coduri-de-bare',
    component: () => import('../views/Distributors/SalesByBarcode.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/produse-isbn',
    name: 'distributors/produse-isbn',
    component: () => import('../views/Distributors/ProductsISBN.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/stock-notices',
    name: 'stocknotices',
    component: () => import('../views/Distributors/StockNotices.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin']  }
  },
  {
    path: '/seo',
    name: 'seo/summary',
    component: () => import('../views/SEO/Summary.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'seo']  }
  },
  {
    path: '/seo/products/:productId',
    name: 'seo/summary/products/product',
    component: () => import('../views/SEO/Product.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'seo'] }
  },
  {
    path: '/furnizori/reguli-pret-dinamic',
    name: 'suppliers/dynamic-price-rules',
    component: () => import('../views/Suppliers/DynamicPriceRules.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori/raport',
    name: 'suppliers/report',
    component: () => import('../views/Suppliers/Report.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori/raport-vanzari',
    name: 'suppliers/sales-report',
    component: () => import('../views/Suppliers/SalesReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori/import-facturi-plata-avans',
    name: 'suppliers/import-advance-payment-invoice',
    component: () => import('../views/Suppliers/ImportAdvancePaymentInvoices.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori/comenzi',
    name: 'suppliers/orders',
    component: () => import('../views/Suppliers/Orders.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori/comenzi/:orderId',
    name: 'suppliers/order',
    component: () => import('../views/Suppliers/Order.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori',
    name: 'suppliers',
    component: () => import('../views/Suppliers/Summary.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori/adauga-furnizor',
    name: 'suppliers/add-supplier',
    component: () => import('../views/Suppliers/AddSupplier.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori/lista-furnizori',
    name: 'suppliers/suppliers',
    component: () => import('../views/Suppliers/Suppliers.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori/lista-furnizori/:supplierId',
    name: 'suppliers/supplier',
    component: () => import('../views/Suppliers/Supplier.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/furnizori/precomanda/:supplierId',
    name: 'suppliers/preorder',
    component: () => import('../views/Suppliers/Preorder.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/generare-e-factura',
    name: 'accounting/generateeinvoice',
    component: () => import('../views/Accounting/GenerateEInvoice.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-payu',
    name: 'accounting/payureport',
    component: () => import('../views/Accounting/PayUReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-emag',
    name: 'accounting/emagreport',
    component: () => import('../views/Accounting/EmagReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-altex',
    name: 'accounting/altexreport',
    component: () => import('../views/Accounting/AltexReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-awb',
    name: 'accounting/awbreport',
    component: () => import('../views/Accounting/AWBReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-2perf',
    name: 'accounting/raport2perf',
    component: () => import('../views/Accounting/PerfReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-facturi',
    name: 'accounting/invoicesreport',
    component: () => import('../views/Accounting/InvoicesReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-receptie-marfa',
    name: 'accounting/stock-reception-report',
    component: () => import('../views/Accounting/StockReceptionReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-facturi-detalii/:year/:month/:series/:totalNumber',
    name: 'accounting/invoicesreportdetails',
    component: () => import('../views/Accounting/InvoicesReportDetails.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/verificare-lista-awb',
    name: 'accounting/verifyawbslist',
    component: () => import('../views/Accounting/VerifyAWBsList.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-miscari-stocuri',
    name: 'accounting/StockMovementReport',
    component: () => import('../views/Accounting/StockMovementReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/contabilitate/raport-verificare-facturi',
    name: 'accounting/InvoicesCheckReport.vue',
    component: () => import('../views/Accounting/InvoicesCheckReport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/vanzari/agenti',
    component: () => import('../views/Sales/Users.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/vanzari/agenti/:userId',
    component: () => import('../views/Sales/User.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/vanzari/rapoarte-activitate',
    component: () => import('../views/Sales/ActivityReports.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/vanzari/detalii-vizita/:visitId',
    component: () => import('../views/Sales/VisitDetails.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/vanzari/rapoarte-nivel-vanzari',
    component: () => import('../views/Sales/SalesLevelReports.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/vanzari/rapoarte-progres-vizita',
    component: () => import('../views/Sales/Progress.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/vanzari/targuri/',
    component: () => import('../views/Sales/Fairs.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/vanzari/targuri/adauga/',
    component: () => import('../views/Sales/AddFair.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] },
  },
  {
    path: '/vanzari/targuri/:fairId/',
    component: () => import('../views/Sales/Fair.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/redactie/achizitii-titluri/:titlePurchaseId',
    component: () => import('../views/Editorial/TitlePurchase.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/redactie/achizitii-titluri/',
    component: () => import('../views/Editorial/TitlePurchases.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/redactie/adauga-titlu-achizitionat/',
    component: () => import('../views/Editorial/AddPurchasedTitle.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/distribuitori/produse-noi-necomandate/',
    component: () => import('../views/Distributors/NewProductsNotOrdered.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/audiobooks/',
    name: 'audiobooks',
    component: () => import('../views/Audiobooks.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/add-audiobook/',
    name: 'add-audiobook',
    component: () => import('../views/AddAudiobook.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/edit-audiobook/:id',
    name: 'edit-audiobook',
    component: () => import('../views/EditAudiobook.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/sales-audiobooks/',
    name: 'sales-audiobooks',
    component: () => import('../views/Reports/SalesAudiobooks.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'reports'] }
  },
  {
    path: '/add-future-release/',
    name: 'add-future-release',
    component: () => import('../views/AddFutureRelease.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/list-future-releases/',
    name: 'list-future-releases',
    component: () => import('../views/ListFutureRelease.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/get-future-release/:id',
    name: 'get-future-release',
    component: () => import('../views/EditFutureRelease.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/cache',
    name: 'cache',
    component: () => import('../views/Cache.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin'] }
  },
  {
    path: '/librarii/analiza-vanzari',
    name: 'libraries/sales-analysis',
    component: () => import('../views/Libraries/SalesAnalysis.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'librarymanager'] }
  },
  {
    path: '/librarii/comenzi-furnizori',
    name: 'libraries/suppliers-orders',
    component: () => import('../views/Libraries/Orders.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'librarymanager'] }
  },
  {
    path: '/librarii/adauga-comanda',
    name: 'libraries/add-order',
    component: () => import('../views/Libraries/AddOrder.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'librarymanager'] }
  },
  {
    path: '/librarii/comenzi/:orderId',
    name: 'librarii/order',
    component: () => import('../views/Libraries/Order.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'librarymanager'] }
  },
  {
    path: '/librarii/glovo/export-catalog-glovo',
    name: 'libraries/glovo/export-glovo-portfolio',
    component: () => import('../views/Libraries/GlovoPortfolioExport.vue'),
    meta: { requiresAuth : true, roles: ['admin', 'superadmin', 'librarymanager']  }
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
